import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumn from "./AbstractPeriodColumn.js";

/**
 * Opening balance report column.
 */
class OpeningBalanceColumn extends AbstractPeriodColumn {
	accept(visitor) {
		return visitor.visitOpeningBalanceColumn(this);
	}

	isBalanceColumn() {
		return true;
	}

	_getDefaultTitle() {
		return _("OB {period}", {
			period: super._getDefaultTitle(),
		});
	}

	_operation() {
		return "openingBalance";
	}

	static getType() {
		return "OpeningBalanceColumn";
	}
}

export default OpeningBalanceColumn;
